import * as React from 'react';
import { IBanner } from '../../interfaces';
import Axios, { AxiosResponse } from 'axios';
import config from '../../config';

declare var FB: any;

interface IProps {
    className: string,
    place: number,
    style?: React.CSSProperties
}

interface IState {
    banner: IBanner,
    html: string,
    script: string
}

export default class Banner extends React.Component<IProps, IState> {
    private _isUnmounted = false;

    constructor(props: IProps) {
        super(props);

        this.state = {
            banner: null,
            html: null,
            script: null,
        }
    }

    componentWillUnmount (){
        this._isUnmounted = true;
    }

    async componentDidMount() {
        try {
            let response: AxiosResponse = await Axios.get(`${config.host}/banner/place?number=${this.props.place}`);

            let { data } = response;

            if (data && this.props.place == 41) {
                $(".i-body.main-body .container.v-index").addClass("index");
            }

            if (data.is_inner == 0) {
                let htmlResponse = data.link;
                htmlResponse = htmlResponse.replace('<script async src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>', '');
                htmlResponse = htmlResponse.replace('<script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js">', '');

                let extractedScript = /<script[\s\S]*?>[\s\S]*<\/script>/g.exec(htmlResponse)[0];

                if (!this._isUnmounted)
                    this.setState({
                        html: htmlResponse,
                        script: extractedScript,
                        banner: {
                            ...response.data,
                            link: htmlResponse
                        },
                    });

            } else {
                if (!this._isUnmounted)
                    this.setState({
                        banner: response.data,
                    });
            }

            FB.XFBML.parse();


        } catch (err) {

        }
    }

    componentDidUpdate() {
        // this runs the contents in script tag on a window/global scope
        let scriptToRun = this.state.script;

        if (scriptToRun) {
            scriptToRun = scriptToRun.replace(/<script[\s\S]*?>/g, "");
            scriptToRun = scriptToRun.replace(/<\/script>/g, "");

            //remove <script> and </script> tags since eval expects only code without html tags
            try {
                (window as any).eval(scriptToRun)
            } catch (err) {
            }
        }

    }

    render() {
        return (
            <div style={{ ...this.props.style }} className={this.props.className}>
                {this.state.banner && this.state.banner.is_inner == 1 && (
                    <a href={this.state.banner.path} target="_blank">
                        <img className="img-responsive" style={{ height: "100%", margin: "auto" }} src={this.state.banner.fullPath} alt="" />
                    </a>
                )}
                {this.state.banner && this.state.banner.is_inner == 0 && (
                    <div className="w-100 h-100" dangerouslySetInnerHTML={{
                        __html: this.state.banner.link
                    }}></div>
                )}
            </div>
        );
    }
}